import { createSelector } from 'reselect';
import { ERECRUITMENT } from './constants';
import { initialState } from './reducers';
import { hasValue } from '@helpers/utils/utils';

const eRecruitmentState = (state) => state[ERECRUITMENT];

const selERecruitmentPendingData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.eRecruitmentPendingData.data || [],
);

const selERecruitmentProcessedData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.eRecruitmentProcessedData.data || [],
);

const selADERecruitmentPendingData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.ADERecruitmentPendingData?.data || [],
);

const selADERecruitmentCourseData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.ADERecruitmentCourseData?.data || [],
);

const selADERecruitmentInfoCandidateCourseData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.ADERecruitmentInfoCandidateCourseData?.data || [],
);

const selADERecruitmentClassCandidateCourseData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.ADERecruitmentClassCandidateCourseData || [],
);

const selADERecruitmentProcessedData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.ADERecruitmentProcessedData?.data || [],
);

const selAOSERecruitmentPendingData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.AOSERecruitmentPendingData?.data || [],
);

const selAOSERecruitmentProcessedData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.AOSERecruitmentProcessedData?.data || [],
);

const selFilterConfig = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => {
    return hasValue(_eRecruitmentState.filterConfig)
      ? _eRecruitmentState.filterConfig
      : initialState.filterConfig;
  },
);

const selADFilterConfig = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => {
    return hasValue(_eRecruitmentState.ADFilterConfig)
      ? _eRecruitmentState.ADFilterConfig
      : initialState.ADFilterConfig;
  },
);

const selAOSFilterConfig = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => {
    return hasValue(_eRecruitmentState.AOSFilterConfig)
      ? _eRecruitmentState.AOSFilterConfig
      : initialState.AOSFilterConfig;
  },
);

const selStatusData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.statusData?.data || [],
);

const selAllAdData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.allAdData?.data || [],
);

const selAllAmData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.allAmData?.data || [],
);

const selListTrainingClassData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.listTrainingClassData?.data || [],
);

const selListOfValueData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.listOfValueData || [],
);

const selProvincesData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.provincesData?._embedded?.province || [],
);

const selDistrictsData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.districtsData?._embedded?.district || [],
);

const selWardsData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.wardsData?._embedded?.ward || [],
);

const selListOffice = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.listOfficeData?.data || [],
);

const selRegisterSuccess = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.register || null,
);

const selCheckDuplicatedPhoneSuccess = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.checkDuplicatedPhone || null,
);

const selGetTrackingSuccess = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.tracking || null,
);

const selFilesData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.files || null,
);

const selKaptchaImage = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.kaptcha || null,
);

const selEreDetail = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.eReDetail || null,
);
// DETAIL
const selPreCandidateDetailData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.preCandidateDetailData || {},
);
const selEappProcessHistoriesData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.eappProcessHistoryData || {},
);
const selDocBufferedData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.docBufferedData || {},
);

const selAscore = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.aScore || {},
);

const selTitleForNous = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.titleForNousData?.FTA_CHNL || [],
);

const selNousPreCandidateDetailData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.nousPreCandidateDetailData || {},
);

const selNousAscore = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.nousAscore || {},
);

const selFlairPreCandidateDetailData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.flairPreCandidateDetailData || {},
);

const selFlairBankOfficesData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.flairBankOfficesData || {},
);

const selFlairTeamOfficesData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.flairTeamOfficesData || {},
);

const selFlairAmTeamsData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.flairAmTeamsData || {},
);

const selFlairAdTeamsData = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.flairAdTeamsData || {},
);

const selERecruitmentPreCandidateId = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.eRecruitmentPreCandidateId || null,
);
const selERecruitmentPreCandidateChannelCode = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) =>
    _eRecruitmentState.eRecruitmentPreCandidateChannelCode || null,
);
const selEAppProcessHistoriesDataV2 = createSelector(
  eRecruitmentState,
  (_eRecruitmentState) => _eRecruitmentState.eAppProcessHistoryDataV2 || [],
);

export {
  selERecruitmentPendingData,
  selERecruitmentProcessedData,
  selADERecruitmentPendingData,
  selADERecruitmentProcessedData,
  selADERecruitmentCourseData,
  selADERecruitmentInfoCandidateCourseData,
  selADERecruitmentClassCandidateCourseData,
  selFilterConfig,
  selADFilterConfig,
  selStatusData,
  selListOfValueData,
  selProvincesData,
  selDistrictsData,
  selWardsData,
  selListOffice,
  selRegisterSuccess,
  selCheckDuplicatedPhoneSuccess,
  selAllAdData,
  selListTrainingClassData,
  selGetTrackingSuccess,
  selFilesData,
  selKaptchaImage,
  selPreCandidateDetailData,
  selEappProcessHistoriesData,
  selDocBufferedData,
  selEreDetail,
  selAscore,
  selAOSFilterConfig,
  selAOSERecruitmentPendingData,
  selAOSERecruitmentProcessedData,
  selAllAmData,
  // nous
  selTitleForNous,
  selNousPreCandidateDetailData,
  selNousAscore,
  // flair
  selFlairPreCandidateDetailData,
  selFlairBankOfficesData,
  selFlairTeamOfficesData,
  selFlairAmTeamsData,
  selFlairAdTeamsData,
  selERecruitmentPreCandidateId,
  selERecruitmentPreCandidateChannelCode,
  // delasol
  selEAppProcessHistoriesDataV2,
};
